<template>
  <div class="page">
    <p class="p1">
      签约详情
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="d_nei">
      <p>
        <span>ICCID：</span><span class="p_c">{{propsParams.iccid}}</span>
      </p>
      <p>
        <span>签约号：</span><span class="p_c">{{propsParams.outAgreementNo}}</span>
      </p>
      <p>
        <span>签约套餐：</span><span class="p_c">{{propsParams.productName}}</span>
      </p>
      <p>
        <span>签约时间：</span><span class="p_c">{{propsParams.validTime}}</span>
      </p>
      <p>
        <span>套餐价格：</span><span class="p_c">{{'¥'+ propsParams.price}}</span>
      </p>
      <p>
        <span>签约价格：</span><span class="p_c"> {{'¥'+ propsParams.renewalPrice}}</span>
      </p>
      <p>
        <span>支付手机号：</span><span class="p_c"> {{propsParams.verificationPhone}}</span>
      </p>
      <div class="d_phone">
          <nut-textinput placeholder="请输入验证码" v-model="propsParams.code" type="tel" maxlength="4" :clearBtn="false"/>
          <div class="input-code">
            <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
            <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
          </div>
      </div>
    </div>
    <div class="footer">
      <nut-button @click="rescindButton()">确定解约</nut-button>
    </div>
  </div>
</template>
<script>
import { wx_agreementInfo } from "@/api/api.js"; //获取初始化数据
import { wx_sendRelieveSms } from "@/api/api.js"; //发送验证码
import { wx_relieveAgreement } from "@/api/api.js"; //解除约定
export default {
  data() {
    return {
      propsParams:{},
      // 倒计时的显示
      show: true,
      count: "",
      timer: null,
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);  
    },
    // 获取验证码
    getCode(){
      let params={
        phone: this.propsParams.phone,
        iccid:this.$route.query.iccid
      }
      wx_sendRelieveSms(params).then(res=>{
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
    },
    initData(){
      wx_agreementInfo({iccid:this.$route.query.iccid}).then(res =>{
        if(res.data.code == 200){
          this.propsParams = res.data.data;
          let packageData = JSON.parse(res.data.data.productInfo);
          this.propsParams.productName = packageData.productName;
          this.propsParams.renewalPrice = packageData.renewalPrice;
          this.propsParams.verificationPhone = this.propsParams.phone.substr(0,3) + "****" + this.propsParams.phone.substr(7,11)
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    },
    // 确认解约
    rescindButton(){
      let params ={
        outAgreementNo:this.propsParams.outAgreementNo,
        code:this.propsParams.code,
        phone:this.propsParams.phone
      }
      wx_relieveAgreement(params).then(res=>{
        if(res.data.code == 200){
          this.$toast.success("解约成功");
          setTimeout(()=>{
            this.$router.push({
              name: "info",
              query: {
                iccid: this.$route.query.iccid
              }
            })
          },1500)
        }else{
          this.$toast.fail(res.data.message);
        }
      })

    }
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "查询订单";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .d_nei{
      width: 95%;
      background: #fff;
      margin: 0 auto;
      padding: 5px;
      p{
        font-size: 14px;
        padding: 13px;
        display: flex;
        justify-content: space-between;
        .p_c{
          color: #F94040;
        }
      }
      .d_phone{
        width: 90%;
        margin: 0 auto;
        position: relative;
        /deep/ .nut-textinput input{
          width: 100%;
          margin-top: 15px;
          border: 2px solid #f94040;
          color: #999;
          font-size: 14px;
        }
      }
      .input-code {
        position: absolute;
        right: 15px;
        top: 37%;
        height: 30px;
        .opt-a {
          display: block;
          width: 75px;
          height: 30px;
          line-height: 30px;
          background: #F94040;
          color: #fff;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
  }
</style>

